import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { SurveysBySessionRow } from '../surveys-by-session-view.part';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<SurveysBySessionRow> {

	return {
		rowName: { singular: 'Session Response', plural: 'Session Responses' },
		getRowKey: row => '' + row.accSessionSurveyResponseId,
		stateKey: 'accelerator-surveys-by-session-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
	}
}
